import { BadgeOption } from 'src/types';
import { PAYMENT_TYPE, PRICING_MODEL } from 'src/features/servicePlanPricingPolicies/utils/types';
import { pricingPoliciesMessages } from 'src/features/servicePlanPricingPolicies/utils/messages';

export const PAYMENT_TYPE_BADGE_OPTIONS: Record<PAYMENT_TYPE, BadgeOption> = {
    [PAYMENT_TYPE.PRE]: {
        label: pricingPoliciesMessages.pre,
        theme: 'green',
    },
    [PAYMENT_TYPE.POST]: {
        label: pricingPoliciesMessages.post,
        theme: 'red',
    },
}

export const PAYMENT_TYPE_MAP: Record<PAYMENT_TYPE, { id: string, defaultMessage: string}> = {
    [PAYMENT_TYPE.PRE]: pricingPoliciesMessages.pre,
    [PAYMENT_TYPE.POST]: pricingPoliciesMessages.post,
};

export const PRICING_MODEL_BADGE_OPTIONS: Record<PRICING_MODEL, BadgeOption> = {
    [PRICING_MODEL.FLAT]: {
        label: pricingPoliciesMessages.pricingModelFlat,
        theme: 'teal',
    },
    [PRICING_MODEL.PER_UNIT]: {
        label: pricingPoliciesMessages.pricingModelPerUnit,
        theme: 'orange',
    },
}


export const PRICING_MODEL_MAP: Record<PRICING_MODEL, { id: string, defaultMessage: string}> = {
    [PRICING_MODEL.FLAT]: pricingPoliciesMessages.pricingModelFlat,
    [PRICING_MODEL.PER_UNIT]: pricingPoliciesMessages.pricingModelPerUnit,
};
